/**
 * Value for the `.code[Type]` codeable concept
 */
export enum ChargeItemDefinitionCode {
  /**
   * ChargeItemDefinition is intended for use as a medical aid claim line
   */
  ClaimLine = 'chargeitemdefinition.code.type.claimline',
}

export enum Currency {
  ZAR = 'ZAR',
}

export const CHARGE_ITEM_DEFINITION_APPLICABILITY_LANGUAGE =
  'text/quro-charge-item-definition';
